import QTable from 'quasar/src/components/table/QTable.js';

export const adminProfitIndexPageTableColumn = (): QTable['columns'] => [
  {
    name: 'id',
    field: 'id',
    label: 'شماره',
    align: 'center'
  },
  {
    name: 'description',
    field: 'description',
    label: 'توضیحات',
    classes: 'max-width-200',
    align: 'left',
    format: value => value || ''
  },
  {
    name: 'profitable_type',
    field: 'profitable_type',
    label: 'نوع مدل',
    align: 'center'
  },
  {
    name: 'profitable_id',
    field: 'profitable_id',
    label: 'شماره مدل',
    align: 'center'
  },
  {
    name: 'amount',
    field: 'amount',
    label: 'مقدار',
    align: 'center',
    format: value => value.toLocaleString()
  },
  {
    name: 'type',
    field: 'type',
    label: 'نوع سود',
    align: 'center'
  },
  {
    name: 'created_at',
    field: 'created_at',
    label: 'تاریخ',
    align: 'center'
  },
  {
    name: 'actions',
    field: '',
    label: '',
    align: 'center'
  }
]
